import Goo from "gooey-react";
import React from "react";
function Test() {
 return(
     <>
         <Goo intensity={"medium"}>

             {/*<svg style={{ animation: 'left 4s linear infinite' }} width="192" height="192">*/}
             {/*    <circle style={{ animation: 'right 1s linear infinite' }}  cx="37%" cy="37%" fill="orchid" r="32" />*/}
             {/*    <circle cx="63%" cy="63%" fill="mediumorchid" r="32" />*/}
             {/*</svg>*/}
                 <svg style={{animation:" 9s linear 0s infinite normal none running rotate_back"}} width="192" height="192">

                     <circle cx="50%" cy="50%" r="42" fill="lightseagreen"
                             style={{animation: "12s ease-in-out -3s infinite alternate none running blob_four"}}></circle>
                     <circle cx="50%" cy="50%" r="36" fill="lightgreen"
                             style={{animation: "9s ease-in-out -3s infinite alternate none running blob_three"}}></circle>
                     <circle cx="50%" cy="50%" r="30" fill="palegreen"
                             style={{animation: "6s ease-in-out -3s infinite alternate none running blob_two"}}></circle>
                     <circle cx="50%" cy="50%" r="24" fill="mediumspringgreen"
                             style={{animation: "3s ease-in-out -3s infinite alternate none running blob_one"}}></circle>

             </svg>

         </Goo>
     <div>
         This Is out Of Scope
     </div>
         </>
 )
}
export default Test;